/* sb-dc-sizeguard.js - refuses an add to cart whose variant does not match the
   size on screen.

   Why this exists
   ---------------
   On 2026-09-01, in a 433px window, a banner designed at 8x4 ft - editor and
   proof both showing 8' x 4' (96" x 48") and $63.68 - was added to the cart as
   "16 / 4" at $127.36. Exactly double the width, exactly double the price.
   window.__dcApi.spec still read widthIn:96 afterwards, so the editor's own
   state was never wrong; only the variant the cart module resolved was.

   It did not reproduce on the next two runs at the same width, and the same
   flow on a 2133px window has always been correct, so this is intermittent
   rather than a plain width bug. The root cause is still open.

   What it does
   ------------
   Sits on /cart/add.js and compares the variant being sent against the size
   the customer is looking at. On a mismatch the request is refused before it
   reaches Shopify and the customer is told to try again, instead of paying for
   and receiving a banner twice the size they designed. Every block is recorded
   in dc_events as cart_add_size_block with both sizes, which is what will
   eventually pin down the cause - the failure is rare enough that catching it
   in the wild beats trying to reproduce it.

   Deliberately cautious - it must never block a good order:
   - only lines carrying a print file are checked; add-ons (stand, red carpet)
     have no size of their own and pass straight through
   - if the variant table has not arrived within 3 seconds, or the id is not in
     it, or the size cannot be parsed, the add proceeds unchecked
   - the comparison is numeric with a small tolerance, not string equality
   - anything unexpected is caught and the add proceeds

   Load order: after sb-dc-varfix.js, before cartprops/cartlog, so the body it
   inspects is the one that actually goes to the network. */
(function () {
  var SB = 'https://uktrkymhgmzlufzxsavf.supabase.co/rest/v1';
  var KEY = 'sb_publishable_6_IwzTvtBpQRo4ZabzRyOA_wAHEDZA2';
  var realFetch = window.fetch.bind(window);
  var maps = {};

  /* variant id -> [w, h] as the catalogue records them. okey is "8|4", or
     "3|5|matte" where a material is part of the variant; only the first two
     segments are sizes. */
  function mapFor(handle) {
    if (maps[handle]) return maps[handle];
    var url = SB + '/dc_variants?handle=eq.' + encodeURIComponent(handle) +
      '&select=okey,variant_id&limit=5000';
    maps[handle] = realFetch(url, { headers: { apikey: KEY, Authorization: 'Bearer ' + KEY } })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (rows) {
        var m = {};
        rows.forEach(function (row) {
          var parts = String(row.okey).split('|');
          var w = parseFloat(parts[0]), h = parseFloat(parts[1]);
          if (isFinite(w) && isFinite(h)) m[String(row.variant_id)] = [w, h];
        });
        return m;
      })
      .catch(function () { return {}; });
    return maps[handle];
  }

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise(function (res) { setTimeout(function () { res(null); }, ms); })
    ]);
  }

  /* What the customer is looking at, in the units the variant options use:
     inches for stickers and decals, feet for banners. */
  function onScreenSize() {
    var api = window.__dcApi;
    if (!api || !api.spec) return null;
    var s = api.spec;
    if (!isFinite(s.widthIn) || !isFinite(s.heightIn)) return null;
    var inch = (typeof window.__dcInch === 'function') ? !!window.__dcInch() : !!window.__dcInch;
    var d = inch ? 1 : 12;
    return { w: s.widthIn / d, h: s.heightIn / d, handle: s.__dcProd || null };
  }

  function near(a, b) { return Math.abs(a - b) < 0.02; }

  function readBody(init) {
    try {
      if (!init || typeof init.body !== 'string') return null;
      return JSON.parse(init.body);
    } catch (e) { return null; }
  }

  function hasPrintFile(props) {
    if (!props) return false;
    for (var k in props) {
      if (/uploaded file|print file/i.test(k) && props[k]) return true;
    }
    return false;
  }

  function record(handle, expected, actual, id) {
    try {
      realFetch(SB + '/dc_events', {
        method: 'POST',
        headers: {
          apikey: KEY,
          Authorization: 'Bearer ' + KEY,
          'Content-Type': 'application/json',
          Prefer: 'return=minimal'
        },
        body: JSON.stringify({
          kind: 'cart_add_size_block',
          ref: handle || null,
          meta: {
            on_screen: expected.w + 'x' + expected.h,
            variant_says: actual[0] + 'x' + actual[1],
            variant_id: id,
            width: window.innerWidth
          }
        })
      });
    } catch (e) { /* logging must never affect the order */ }
  }

  function notify(msg) {
    try {
      var el = document.getElementById('sb-dc-sizeguard-note');
      if (!el) {
        el = document.createElement('div');
        el.id = 'sb-dc-sizeguard-note';
        el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
          'z-index:2147483647;max-width:min(560px,92vw);background:#b3261e;color:#fff;' +
          'font:600 14px/1.45 Arial,sans-serif;padding:14px 18px;border-radius:10px;' +
          'box-shadow:0 8px 28px rgba(0,0,0,.28);cursor:pointer';
        el.addEventListener('click', function () { el.remove(); });
        document.body.appendChild(el);
      }
      el.textContent = msg;
    } catch (e) { /* never let the notice break the page */ }
  }

  window.fetch = function () {
    var args = arguments;
    var input = args[0], init = args[1];
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    if (url.indexOf('/cart/add') === -1) return Reflect.apply(realFetch, this, args);

    var body = readBody(init);
    var size = onScreenSize();
    var id = body && (body.id || (body.items && body.items[0] && body.items[0].id));
    var props = body && (body.properties || (body.items && body.items[0] && body.items[0].properties));

    /* Not something we can judge, or not the designed line - let it go. */
    if (!body || !size || !id || !size.handle || !hasPrintFile(props)) {
      return Reflect.apply(realFetch, this, args);
    }

    var self = this;
    return withTimeout(mapFor(size.handle), 3000).then(function (map) {
      var actual = map && map[String(id)];
      if (!actual) return Reflect.apply(realFetch, self, args);
      if (near(actual[0], size.w) && near(actual[1], size.h)) {
        return Reflect.apply(realFetch, self, args);
      }

      record(size.handle, size, actual, id);
      notify('Something went wrong reading your size, so we stopped the order rather than ' +
             'send the wrong one to print. Please reload the page and try again, or call ' +
             '1-855-622-7272 and we will place it for you.');
      window.__dcSizeBlock = { onScreen: [size.w, size.h], variant: actual, id: id };

      return new Response(JSON.stringify({
        status: 422,
        message: 'Size mismatch',
        description: 'The selected variant does not match the designed size.'
      }), { status: 422, headers: { 'Content-Type': 'application/json' } });
    }).catch(function () {
      return Reflect.apply(realFetch, self, args);
    });
  };

  window.__dcSizeGuard = function () {
    return { installed: true, blocked: window.__dcSizeBlock || null };
  };
})();
